module.exports = __webpack_public_path__ + "img/wor.296cde0b.svg";